import axios from '@/services/axiosConfig'
import ParamMaker from '@/utils/modules/ParamMaker'

const endPoint = {
	getMigrationStatus: status =>
		`/user/migration/status${status ? `?status=${status}` : ''}`,
	completeFirstVisit: status => `/user/migration/firstvisit`,
}

const MigrationAPI = {
	getMigrationStatus: () => axios.get(endPoint.getMigrationStatus()),
	getMigrationStatusTest: status =>
		axios.get(endPoint.getMigrationStatus(status)),
	completeFirstVisit: () => axios.post(endPoint.completeFirstVisit()),
}

export default MigrationAPI
